import { createTheme } from "@material-ui/core/styles";
const fontSize75 = "0.75rem !important";
const fontSize875 = "0.875rem !important";

const SummaryTheme = createTheme({
  palette: {},
  props: {
    MuiSvgIcon: {
      fontSize: "small",
    },
    MuiIconButton: {
      color: "primary",
    },
    MuiButton: {
      disableElevation: true,
      color: "primary",
      size: "small",
      variant: "contained",
    },
    MuiTextField: {
      variant: "filled",
    },
    MuiSelect: {
      variant: "filled",
    },
  },
  overrides: {
    MuiTextField: {
      root: {
        margin: ".25rem 0 0 .25rem",
      },
    },
    MuiInput: {
      input: {
        fontSize: fontSize75,
        padding: "0 .5rem .25rem 0.25rem",
        marginTop: "0.25rem",
      },
    },
    MuiFilledInput: {
      root: {
        borderRadius: "0 !important",
        backgroundColor: "rgba(0, 0, 0, 0.05)",
        "&::before": {
          border: "none !important",
        },
      },
      input: {
        padding: "6px 8px 6px !important",
        fontSize: fontSize75,
        color: "black",
      },
      multiline: {
        padding: "0",
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: fontSize875,
      },
      shrink: {
        color: "#000000 !important",
      },
    },
    MuiInputAdornment: {
      root: {
        marginTop: "3px !important",
      },
    },
    MuiSelect: {
      select: {
        padding: "4px 8px !important",
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
        textTransform: "capitalize !important",
        // padding: "0 !important"
      },
    },
    MuiIconButton: {
      root: {},
      colorPrimary: {
        "&:hover": {
          backgroundColor: "#d3f0f0",
        },
      },
      colorSecondary: {
        "&:hover": {
          backgroundColor: "#d3f0f0",
        },
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: fontSize75,
        color: "#000000",
      },
    },
    MuiFormControlLabel: {
      root: {
        marginBottom: 0,
      },
      label: {
        fontSize: fontSize75,
        textAlign: "justify",
      },
    },
    MuiTypography: {
      body1: {
        fontSize: fontSize75,
      },
    },
    MuiTableContainer: {
      root: {
        boxShadow: "0 0 5px 0 rgb(224 224 224)",
      },
    },
  },
});

export default SummaryTheme;
